import { z } from 'zod';
import { IsoDateTime } from './common.ts';

/**
 * What a user did with a Content Card (BB-69, CARD-007/008), reported by the SDK in its batch. `impression` follows
 * the viewport rule (at least half of the card visible for at least one second, once per card and session);
 * `click`, `dismiss` and `read` are logged when they happen. The server keeps read and dismiss profile-wide: a card
 * dismissed on one device leaves the feed of every device at their next sync; read and dismiss are never undone.
 */
export const CARD_INTERACTION_KINDS = ['impression', 'click', 'dismiss', 'read'] as const;
export type CardInteractionKind = (typeof CARD_INTERACTION_KINDS)[number];

export const CardInteractionOperation = z.object({
  type: z.literal('card_interaction'),
  operationId: z.uuid(),
  occurredAt: IsoDateTime,
  sessionId: z.uuid().optional(),
  kind: z.enum(CARD_INTERACTION_KINDS),
  /** The card instance id from the feed. */
  cardId: z.uuid(),
  /** Where the app showed the card (a VCG placement such as `home_banner`), for analytics only. */
  placement: z.string().min(1).max(100).optional(),
});
export type CardInteractionOperation = z.infer<typeof CardInteractionOperation>;
